<section class="ao-block mb-0" *ngIf="items && items.length && show">
  <header class="ao-header">
    <div class="row">
      <div class="col-sm-6">
        <h2 class="ao-header-title text-overflow">{{ title }}</h2>
      </div>
      <div class="col-sm-6 text-right total-records">
        {{ totalRecordLabel }}
        <strong>{{ totalNumberOfRecordsAvailable }}</strong>
      </div>
    </div>
  </header>

  <div class="table-responsive">
    <table class="table table-hover ao-table">
      <thead>
        <tr>
          <th *ngFor="let column of columns">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items">
          <td>{{ item.userId }}</td>
          <td>{{ item.logDateTime | date: 'MM/dd/yyyy hh:mm:ss' }}</td>
          <td>{{ item.ipAddress }}</td>
          <td>{{ item.messages }}</td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="isLoading" class="loader-bar"></div>
  </div>
  <div
    *ngIf="hasMore"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [fromRoot]="true"
    (scrolled)="onScroll()"
  ></div>
</section>
